import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Text } from '../../..';
import { FontColorType } from '../../../../helpers';

type Props = {
  color?: FontColorType;
  TrailingIcon?: React.ReactElement;
  children: React.ReactNode;
  isBold?: boolean;
  as?: React.ElementType;
  isCompactMode?: boolean;
};

const titleContainerStyle = css`
  overflow-x: hidden;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: inline;
  white-space: nowrap;
`;

const titleBaseStyle = css`
  display: inline;
  line-height: 1;
  padding-right: ${theme.spacing(1)};
`;

const titleFontSizeStyles = {
  compact: css`
    font-size: ${theme.fontSize(14)};
  `,
  normal: css`
    font-size: ${theme.fontSize(16)};
  `,
};

export const ListRowTitle = ({
  color = 'default',
  TrailingIcon,
  children,
  isBold = true,
  as = Text,
  isCompactMode,
  ...rest
}: Props) => {
  const Component = as;

  return (
    <div
      className={cx(titleContainerStyle, 'content-column-title-container')}
      /* color for ellipsis should match color of text */
      style={{ color }}
    >
      <Component
        size='large'
        weight={isBold ? 'bold' : 'inherit'}
        color={color}
        className={cx(
          titleBaseStyle,
          isCompactMode ? titleFontSizeStyles.compact : titleFontSizeStyles.normal,
          'content-column-title'
        )}
        {...rest}
      >
        {children}
      </Component>
      {!!TrailingIcon && TrailingIcon}
    </div>
  );
};
